import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Mail, Instagram, Twitter, Youtube, MessageCircle } from 'lucide-react';

export default function Footer() {
  const footerLinks = [
    { label: 'About', href: '#about', type: 'hash' },
    { label: 'Contact us', href: 'mailto:contact@ekalavya.edu', type: 'external' },
    { label: 'Our Team', href: '/team', type: 'route' },
    { label: 'Verify Certificate', href: '/verify-certificate', type: 'route' },
    { label: 'Privacy Policy', href: '#', type: 'external' },
    { label: 'Terms and Conditions', href: '#', type: 'external' },
  ];

  const socialLinks = [
    { icon: <Instagram size={18} />, href: 'https://www.instagram.com/ekalavya_nxt/', label: 'Instagram', hoverBg: '#E1306C' },
    { icon: <Twitter size={18} />, href: '#', label: 'X (Twitter)', hoverBg: '#000000' },
    { icon: <Linkedin size={18} />, href: 'https://www.linkedin.com/company/ekalavya-edtech/', label: 'LinkedIn', hoverBg: '#0077b5' },
    { icon: <Youtube size={18} />, href: '#', label: 'YouTube', hoverBg: '#FF0000' },
    { icon: <MessageCircle size={18} />, href: 'https://whatsapp.com/channel/0029VbDOL8n4tRrxD0letf2u', label: 'WhatsApp', hoverBg: '#25D366' },
  ];

  return (
    <footer style={{
      background: '#fafafa',
      borderTop: '1px solid #e5e7eb',
      fontFamily: "'Poppins', sans-serif",
    }}>
      {/* ── Main row: Logo | Links | Socials ── */}
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '2rem 2rem 1.5rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: '1.5rem',
      }}>
        {/* Logo + Brand */}
        <Link to="/" style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.6rem',
          textDecoration: 'none',
          flexShrink: 0,
        }}>
          <div className="logo-container">
            <img src="/Logo.jpeg" alt="Ekalavya" className="logo-img" />
          </div>
          <span style={{
            fontSize: '1.1rem',
            fontWeight: 700,
            color: '#0f172a',
            letterSpacing: '-0.02em',
          }}>Ekalavya</span>
        </Link>

        {/* Center links with pipe separators */}
        <nav style={{
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'wrap',
          justifyContent: 'center',
          gap: '0.25rem',
        }}>
          {footerLinks.map((link, i) => (
            <React.Fragment key={link.label}>
              {link.type === 'route' ? (
                <Link
                  to={link.href}
                  style={{
                    color: '#4b5563',
                    fontSize: '0.85rem',
                    textDecoration: 'none',
                    padding: '0.25rem 0.5rem',
                    transition: 'color 0.2s',
                  }}
                  onMouseEnter={e => e.currentTarget.style.color = '#9333ea'}
                  onMouseLeave={e => e.currentTarget.style.color = '#4b5563'}
                >
                  {link.label}
                </Link>
              ) : (
                <a
                  href={link.href}
                  style={{
                    color: '#4b5563',
                    fontSize: '0.85rem',
                    textDecoration: 'none',
                    padding: '0.25rem 0.5rem',
                    transition: 'color 0.2s',
                  }}
                  onMouseEnter={e => e.currentTarget.style.color = '#9333ea'}
                  onMouseLeave={e => e.currentTarget.style.color = '#4b5563'}
                >
                  {link.label}
                </a>
              )}
              {i < footerLinks.length - 1 && (
                <span style={{ color: '#d1d5db', fontSize: '0.85rem', userSelect: 'none' }}>|</span>
              )}
            </React.Fragment>
          ))}
        </nav>

        {/* Social icons */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
          flexShrink: 0,
        }}>
          {socialLinks.map(social => (
            <a
              key={social.label}
              href={social.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={social.label}
              style={{
                width: '34px',
                height: '34px',
                borderRadius: '8px',
                border: '1px solid #e5e7eb',
                background: '#ffffff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#4b5563',
                transition: 'all 0.25s ease',
                textDecoration: 'none',
              }}
              onMouseEnter={e => {
                e.currentTarget.style.background = social.hoverBg;
                e.currentTarget.style.color = '#ffffff';
                e.currentTarget.style.borderColor = social.hoverBg;
                e.currentTarget.style.transform = 'translateY(-2px)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.background = '#ffffff';
                e.currentTarget.style.color = '#4b5563';
                e.currentTarget.style.borderColor = '#e5e7eb';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              {social.icon}
            </a>
          ))}
        </div>
      </div>

      {/* ── Copyright bar ── */}
      <div style={{
        borderTop: '1px solid #e5e7eb',
        padding: '1.25rem 2rem',
        textAlign: 'center',
      }}>
        <p style={{
          color: '#9ca3af',
          fontSize: '0.8rem',
          fontStyle: 'italic',
          margin: 0,
          lineHeight: 1.6,
        }}>
          Copyright &copy; 2026 Ekalavya NXT Learn LLP | All rights reserved
        </p>
      </div>
    </footer>
  );
}
